export default () => ({
  serviceRequests: [],
  currentDiagnostic: {},
  reports: [],
  diagnosticReports: [],
  diagnosticDevices: [],
})
